export const initialAbility = [
  {
    action: 'read',
    subject: 'ACL',
  },
  {
    action: 'show',
    subject: 'Auth',
  },
  {
    action: 'manage',
    subject: 'all',
  },
]

export const _ = undefined
